var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaretDownTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38498 3.84789L7.92516 0.444544C7.96269 0.408248 7.98828 0.362138 7.99874 0.311959C8.0092 0.26178 8.00407 0.209752 7.98399 0.162357C7.96391 0.114961 7.92976 0.074296 7.88581 0.0454255C7.84185 0.0165549 7.79003 0.000757009 7.7368 0H0.271251C0.218023 0.000757009 0.166204 0.0165549 0.122249 0.0454255C0.0782952 0.074296 0.0441499 0.114961 0.0240681 0.162357C0.00398636 0.209752 -0.00114398 0.26178 0.00931638 0.311959C0.0197767 0.362138 0.0453653 0.408248 0.0828936 0.444544L3.62308 3.84789C3.72447 3.94438 3.86137 3.99849 4.00403 3.99849C4.14669 3.99849 4.28359 3.94438 4.38498 3.84789V3.84789Z",
    fill: "#0E3348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretDownTwo);
export default __webpack_public_path__ + "static/media/icon-caret-down-two.e946bf6e.svg";
export { ForwardRef as ReactComponent };